import { footerLinks } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="w-full border-t border-background-200/70 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <a href="#home" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-book-open-fill text-lg" />
              </span>
              <span className="font-heading text-xl text-foreground-950">咪咕漫画网</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              咪咕漫画网手机版专为移动端阅读优化，提供安卓版与 iOS 版客户端下载入口。随时随地流畅翻页，收藏追更两不误，陪你度过每个通勤时光。
            </p>
            <div className="mt-5 flex flex-wrap gap-3">
              <a
                href="#home"
                aria-label="官方微信公众号"
                className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 bg-background-50 text-foreground-700 transition-colors hover:border-primary-200 hover:text-primary-700"
              >
                <i className="ri-wechat-fill text-lg" />
              </a>
              <a
                href="#home"
                aria-label="官方微博"
                className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 bg-background-50 text-foreground-700 transition-colors hover:border-primary-200 hover:text-primary-700"
              >
                <i className="ri-weibo-fill text-lg" />
              </a>
              <a
                href="#home"
                aria-label="哔哩哔哩账号"
                className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 bg-background-50 text-foreground-700 transition-colors hover:border-primary-200 hover:text-primary-700"
              >
                <i className="ri-bilibili-fill text-lg" />
              </a>
            </div>
          </div>

          {footerLinks.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <h4 className="text-sm font-bold text-foreground-950">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={link}>
                    <a href="#home" className="text-sm text-foreground-600 transition-colors hover:text-primary-700">
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200/70 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">© 2026 咪咕漫画网 版权所有 · 仅作演示</p>
          <div className="flex flex-wrap gap-4">
            <a href="#home" className="text-xs text-foreground-500 transition-colors hover:text-primary-700">隐私政策</a>
            <a href="#home" className="text-xs text-foreground-500 transition-colors hover:text-primary-700">用户协议</a>
            <a href="#home" className="text-xs text-foreground-500 transition-colors hover:text-primary-700">帮助中心</a>
          </div>
        </div>
      </div>
    </footer>
  );
}